import Layout from '@layout/Index'

export const tekeCustomer = [
  {
    path: '/teke_customer',
    component: Layout,
    children: [
      {
        path: 'table',
        component: () => import('./pages/TekeCustomerTable.vue'),
        name: '客户管理',
        meta: {
          title: '客户管理',
        },
      },
      {
        path: 'form',
        component: () => import('./pages/TekeCustomerForm.vue'),
        name: '添加客户',
        meta: {
          title: '添加客户',
        },
      },
      {
        path: 'update/:id',
        component: () => import('./pages/TekeCustomerUpdate.vue'),
        name: '编辑客户',
        meta: {
          title: '编辑客户',
        },
      },
      {
        path: 'detail/:id',
        component: () => import('./pages/TekeCustomerDetail.vue'),
        name: '客户详细信息',
        meta: {
          title: '客户详细信息',
        },
      },
      {
        path: 'member/:id',
        component: () => import('./pages/TekeCustomerMemberTable.vue'),
        name: '成员管理',
        meta: {
          title: '成员管理',
        },
      },
      {
        path: 'member/form/:id',
        component: () => import('./pages/TekeCustomerMemberForm.vue'),
        name: '添加成员',
        meta: {
          title: '添加成员',
        },
      },
      {
        path: 'member/update/:id',
        component: () => import('./pages/TekeCustomerMemberUpdate.vue'),
        name: '修改成员',
        meta: {
          title: '修改成员',
        },
      },
      {
        path: 'recharge/table/:id',
        component: () => import('./pages/TekeCustomerRechargeTable.vue'),
        name: '客户充值记录',
        meta: {
          title: '客户充值记录',
        },
      },
      {
        path: 'recharge/form/:id',
        component: () => import('./pages/TekeCustomerRechargeForm.vue'),
        name: '新增客户充值信息',
        meta: {
          title: '新增客户充值信息',
        },
      },
      {
        path: 'balance/table/:id',
        component: () => import('./pages/TekeCustomerBalanceTable.vue'),
        name: '客户消费流水',
        meta: {
          title: '客户消费流水',
        },
      },

    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/teke-customer/tekeCustomer.route.js